import React from 'react';
import {
    Avatar,
    Box,
    Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import {
    CheckCircleRounded,
    CreditCardRounded,
} from "@mui/icons-material";

const _GatewaySelectorGrid = ({
    gateways,
    selectedGateway,
    changeGateway,
}) => {
    return (
        <Box>
            <Typography variant="caption" sx={{ fontWeight: 700, color: 'text.secondary', display: 'block', mb: 1.5 }}>
                انتخاب درگاه یا روش پرداخت:
            </Typography>
            <Grid container spacing={2}>
                {gateways.map((item) => {
                    const isSelected = selectedGateway?.Id === item.Id;
                    return (
                        <Grid key={item.Id} size={{ xs: 6, sm: 4, md: 3 }}>
                            <Box
                                onClick={() => changeGateway(item)}
                                sx={{
                                    p: 2,
                                    borderRadius: 3,
                                    border: '2px solid',
                                    borderColor: isSelected ? 'primary.main' : 'divider',
                                    bgcolor: isSelected ? (theme) => theme.palette.mode === 'dark' ? 'rgba(28, 139, 156, 0.15)' : 'rgba(28, 139, 156, 0.05)' : 'background.paper',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease',
                                    textAlign: 'center',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: 1.2,
                                    position: 'relative',
                                    '&:hover': {
                                        borderColor: isSelected ? 'primary.main' : 'primary.light',
                                        transform: 'translateY(-2px)'
                                    }
                                }}
                            >
                                {isSelected && (
                                    <CheckCircleRounded
                                        sx={{
                                            position: 'absolute',
                                            top: 8,
                                            left: 8,
                                            color: 'primary.main',
                                            fontSize: 18
                                        }}
                                    />
                                )}
                                <Avatar
                                    src={item?.Gateway?.Image?.Url}
                                    variant="rounded"
                                    sx={{
                                        width: 48,
                                        height: 48,
                                        bgcolor: 'background.paper',
                                        border: '1px solid',
                                        borderColor: 'divider',
                                        p: 0.5,
                                        '& img': { objectFit: 'contain' }
                                    }}
                                >
                                    <CreditCardRounded sx={{ color: 'text.secondary' }} />
                                </Avatar>
                                <Typography variant="body2" sx={{ fontWeight: 800, color: 'text.primary' }}>
                                    {item.Gateway?.Name || "درگاه پرداخت"}
                                </Typography>
                            </Box>
                        </Grid>
                    );
                })}
            </Grid>
        </Box>
    );
};

export default _GatewaySelectorGrid;
